<template>
  <div id="app">
    <!-- 移动端头部 -->
    <div v-if="showMenus" class="mobile-menus" :class="{'opened-menus':openedMenus}">
      <div v-for="(route,index) in menuRoutes" :key="index" class="mobile-menus-item"
        :class="{'mobile-active':activeMenu==route.path}" @click="scrollToSection(route.path);openedMenus=false">{{route.meta.title}}</div>
    </div>
    <div v-if="isMobile" class="posDiv nav">
      <h1 class="flex-box">
        <img class="logo mobile-logo" src="../public/static/img/logo.png" alt="经方智脑logo">
      </h1>
      <!-- <div class="code">
        <div>873063</div>
        <div>股票代码</div>
      </div> -->
      <div class="mobile-menus-btn" @click="handleMenus"></div>
    </div>
    <!-- PC头部 -->
    <div v-else class="posDiv nav">
      <h1 class="flex-box">
        <img class="logo" src="../public/static/img/logo.png" alt="经方智脑logo">
      </h1>
      <!-- <div class="code">
        <div>873063</div>
        <div>股票代码</div>
      </div> -->
      <div class="menus-wrap">
        <div v-for="route in menuRoutes" :key="route.path" class="menus-item"
          :class="{'active':activeMenu==route.path}"
          @mouseenter="handleMouseEnter(route)"
          @click="scrollToSection(route.path)">{{route.meta.title}}</div>
      </div>
      <div class="login" @click="toCyf">登录</div>
    </div>
    <!-- <div class="menus-box flex-start" v-if="path == '/product'">
      <div class="tabs">
        <div class="tab" :class="{'tab-active':currentIndex==1}" @click="changeTab(1)">智慧停车</div>
        <div class="tab" :class="{'tab-active':currentIndex==2}" @click="changeTab(2)">智能充电</div>
        <div class="tab" :class="{'tab-active':currentIndex==3}" @click="changeTab(3)">移动应用</div>
        <div class="tab" :class="{'tab-active':currentIndex==4}" @click="changeTab(4)">智能硬件</div>
      </div>
      <div class="content" v-if="currentIndex==1 || currentIndex==2 || currentIndex==3">
        <div class="con link" v-if="currentIndex==1" @click="toPage('/product')">
          <img src="./assets/images/park-icon.png"
            alt="车易付拥有车牌识别、道闸、高速道闸、无人值守、城市停车、智慧城市、智慧停车、道闸一体机、车牌识别一体机、停车收费设备、城市停车平台、智慧停车管理系统、车牌识别软件、车牌识别收费系统"
            class="top-icon">
          智慧停车场管理系统
        </div>
        <div class="con link" v-if="currentIndex==2" @click="toPage('/productCharge')">
          <img src="./assets/images/charge-icon.png"
            alt="车易付拥有充电桩、自行车充电桩、汽车充电桩、快充充电桩、慢充充电桩、液冷充电桩、超充站、充电站、光储充、光储充一体化、光伏充电、储能、城市充电平台、停充一体化平台、充电桩投资、充电站投资、充电桩加盟、充电桩多少钱、充电桩多久充满电、充电站合作、家用充电桩。"
            class="top-icon">
          智能充电桩管理系统
        </div>
        <div class="con link" v-if="currentIndex==3" @click="toPage('/productApplet')">
          <img src="./assets/images/applet-icon.png" alt="北京车易付科技股份有限公司拥有易停车、e停宝" class="top-icon">
          e停宝
        </div>
      </div>
      <div class="content" v-else>
        <div class="box1">
          <div class="title">停车场硬件产品</div>
          <div class="dec">
            <div class="item link" @click="toHarware(1)">封闭车场</div>
            <div class="item link" @click="toHarware(2)">车位诱导</div>
            <div class="item link" @click="toHarware(3)">路内停车</div>
          </div>
        </div>
        <div class="box1">
          <div class="title">充电桩硬件产品</div>
          <div class="dec">
            <div class="item link" @click="toPage('/productChargeHw')">充电桩产品</div>
          </div>
        </div>
        <div class="box1">
          <div class="title">门禁通道硬件产品</div>
          <div class="dec">
            <div class="item link" @click="toPage('/productAcs')">门禁通道产品</div>
          </div>
        </div>
      </div>
    </div>
    <div class="menus-box flex-start" v-if="path == '/service'">
      <div class="tabs">
        <div class="tab" :class="{'tab-active':currentIndex==1}" @click="changeTab(1)">了解我们</div>
        <div class="tab" :class="{'tab-active':currentIndex==2}" @click="changeTab(2)">下载中心</div>
        <div class="tab" :class="{'tab-active':currentIndex==3}" @click="changeTab(3)">联系我们</div>
      </div>
      <div class="content" v-if="currentIndex==1 || currentIndex==2 || currentIndex==3">
        <div class="con link" v-if="currentIndex==1" @click="toPage('/company')">
          <img src="./assets/images/company-icon.png" alt="北京车易付科技股份有限公司简介" class="top-icon">
          公司简介
        </div>
        <div class="con link" v-if="currentIndex==2" @click="toPage('/information')">
          <img src="./assets/images/download-icon.png" alt="北京车易付科技股份有限公司资料下载" class="top-icon">
          资料下载
        </div>
        <div class="con link" v-if="currentIndex==3" @click="toPage('/service')">
          <img src="./assets/images/phone-icon.png" alt="北京车易付科技股份有限公司联系方式" class="top-icon">
          联系方式
        </div>
      </div>
    </div>
    <div class="menus-box flex-start" v-if="path == '/platform'">
      <div class="tabs">
        <div class="tab" :class="{'tab-active':currentIndex==1}" @click="changeTab(1)">场景级解决方案</div>
      </div>
      <div class="content">
        <div class="box1">
          <div class="dec">
            <div class="item link" @click="toPage('/platform')">
              <img src="./assets/images/plateform1.png" alt="北京车易付科技股份有限公司停充一体运营增收方案" class="top-icon">
              停充一体运营增收方案
            </div>
          </div>
        </div>
        <div class="box1">
          <div class="dec">
            <div class="item link" @click="toPage('/platformCloud')">
              <img src="./assets/images/plateform2.png" alt="北京车易付科技股份有限公司停车场无人值守云托管方案" class="top-icon">
              停车场无人值守云托管方案
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- PC头部 -->
    <router-view @mouseenter="closeMenus"></router-view>
    <div class="footer">
      <div class="footer-top">
        <div class="footer-top-left">
          <h1 class="footer-title">北京经方智脑科技有限公司</h1>
          <div class="">电话<span class="footer-label">400-623-9981</span></div>
          <div class="">邮箱<span class="footer-label">jingfangzhinao@163.com</span></div>
          <div class="">地址<span class="footer-label">北京市昌平区北大医疗创新谷国信园1号楼309</span></div>
        </div>
        <div v-if="!isMobile">
          <div class="footer-title">产品中心</div>
          <div class="cursor" @click="toPage('/product')">脑电帽</div>
        </div>
        <div v-if="!isMobile">
          <div class="footer-title">关于我们</div>
          <div class="cursor" @click="toPage('/company')">公司简介</div>
          <div class="cursor" @click="toPage('/information')">资料下载</div>
          <div class="cursor" @click="toPage('/service')">联系方式</div>
        </div>
        <div v-if="!isMobile">
          <div class="footer-title">关注我们</div>
          <img src="./assets/images/e.png" alt="经方智脑小程序码" class="wx-img">
          <div style="text-align: center;">小程序</div>
        </div>
      </div>
      <div class="footer-bot">
        <img class="footer-beian" src="./assets/images/beian.png" alt="公安logo"> 京公网安备11011402055487号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;京ICP备2025123210号
      </div>
    </div>
    <!-- <div class="service-box flex-column">
      服务热线
    </div>
    <div class="service-tel flex-center">400-623-9981</div> -->
    <div class="back-top" id="backTop" @click="backTop"></div>
  </div>
</template>
<script>
  import { mapState, menus } from 'vuex'
  import { routes } from './router'

  export default {
    data() {
      return {
        showSelect: false,
        isMobile: false,
        showMenus: true,
        openedMenus: false,
        currentIndex: 1,
        isShow: false,
        path: '',
        activeMenu: '/', // 跟踪当前激活的菜单项
      }
    },
    computed: {
      ...mapState(['menus']),
      menuRoutes() {
        return routes.filter(item => !item.hidden)
      }
    },
    created() {
      const mediaQuery = window.matchMedia("(max-width: 768px)");
      this.isMobile = mediaQuery.matches;
      localStorage.setItem('isMobile', this.isMobile);
      // 监听媒体查询变化
      mediaQuery.addEventListener("change", (e) => {
        this.isMobile = e.matches;
        localStorage.setItem('isMobile', this.isMobile);
      });
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
      // 移除事件监听
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      toHarware(currentIndex) {
        this.path = '',
          window.localStorage.setItem('currentIndex', currentIndex)
        this.$router.push("/productClose")
      },
      changeTab(index) {
        this.currentIndex = index
      },
      toCyf() {
        // window.open('https://www.cheyifu.com.cn/cloud/login')
      },
      handleMouseEnter(route) {
        // this.path = route.path
      },
      closeMenus() {
        this.path = '',
          this.currentIndex = 1
      },
      handleScroll() {
        const backElem = document.getElementById('backTop')
        if (document.documentElement.scrollTop > 0) {
          backElem.classList.remove('back-top-hidden')
        } else {
          backElem.classList.add('back-top-hidden')
        }
        
        // 监听滚动位置，更新导航栏高亮
        const scrollTop = window.scrollY || document.documentElement.scrollTop
        
        // 获取各个区域的位置
        const sections = {
          '/': 0,
          '/solutions': document.querySelector('.section-solutions')?.offsetTop || 0,
          '/scenarios': document.querySelector('.section3')?.offsetTop || 0,
          '/products': document.querySelector('.section4')?.offsetTop || 0,
          '/about': document.querySelector('.section5')?.offsetTop || 0
        }
        
        // 计算当前滚动位置对应的区域
        let currentSection = '/'
        const documentHeight = document.documentElement.scrollHeight
        const windowHeight = window.innerHeight
        
        // 检查是否滚动到页面底部
        if (scrollTop + windowHeight >= documentHeight - 100) {
          currentSection = '/about'
        } else {
          // 否则根据滚动位置判断当前区域
          for (const [path, offsetTop] of Object.entries(sections)) {
            if (scrollTop >= offsetTop - 100) { // 减去100px的偏移量，让高亮提前显示
              currentSection = path
            }
          }
        }
        
        // 更新当前激活的菜单项
        if (this.activeMenu !== currentSection) {
          this.activeMenu = currentSection
        }
      },
      backTop() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth' // 可选，平滑滚动效果
        });
      },
      toPage(url) {
        // this.$router.push(url)
        this.path = ''
        this.currentIndex = 1
      },
      handleMenus() {
        // this.openedMenus = !this.openedMenus
      },
      scrollToSection(path) {
        // 更新当前激活的菜单项
        this.activeMenu = path
        // 首先跳转到首页
        this.$router.push('/')
        
        // 延迟执行滚动，确保页面已经切换到首页
        setTimeout(() => {
          let targetElement = null
          
          switch(path) {
            case '/solutions':
              targetElement = document.querySelector('.section-solutions')
              break
            case '/scenarios':
              targetElement = document.querySelector('.section3')
              break
            case '/products':
              targetElement = document.querySelector('.section4')
              break
            case '/about':
              targetElement = document.querySelector('.section5')
              break
            default:
              // 首页默认滚动到顶部
              window.scrollTo({ top: 0, behavior: 'smooth' })
              return
          }
          
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' })
          }
        }, 100)
      }
    }
  }
</script>
<style lang="scss" scoped>
  #app {
    width: 100%;
  }

  .back-top {
    position: fixed;
    right: 114px;
    bottom: 100px;
    width: 120px;
    height: 120px;
    background: #652EFD url(./assets/images/top.png) center no-repeat;
    background-size: 36px 44px;
    border-radius: 60px;
    cursor: pointer;
    transform-origin: center bottom;
    transition: all 0.3s;
  }

  .back-top-hidden {
    transform: scaleY(0);
  }

  .posDiv {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding: 0.5vh 0 0.5vh 10vw;
    width: 100%;
    height: 7.4vh;
    color: rgba(119, 119, 119, 1);
    background: rgba(255, 255, 255);
    z-index: 9999;
  }

  .cursor {
    cursor: pointer;
  }

  .logo {
    margin-right: 1.6vw;
    width: 13vw;
  }

  .code {
    margin-top: 0.4vh;
    font-size: 28px;
    color: #4E5969;
    text-align: center;
  }

  .login {
    display: flex;
    align-items: center;
    justify-content: center;
    // margin-top: 16px;
    margin-right: 12.5vw;
    width: 6.25vw;
    height: 4vh;
    color: #fff;
    font-weight: 500;
    border-radius: 2vw;
    background-color: #020814;
    cursor: pointer;
  }

  // .login:hover {
  //   background: #E7EDFF;
  // }

  // .login:active {
  //   background: #CFDAFF;
  // }

  .menus-wrap {
    margin-left: auto;
    margin-right: 5.2vw;
    display: flex;
    height: 100%;
  }

  .menus-item {
    display: flex;
    align-items: center;
    margin-right: 60px;
    padding: 0 20px;
    height: 100%;
    border-bottom: 4px solid #fff;
    color: #020814;
    cursor: pointer;
  }

  .menus-box {
    padding-left: 17vw;
    margin-top: 7vh;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 99;
    color: #4E5969;
    font-size: 32px;
    height: 20vh;
  }

  .tabs {
    padding: 1vw 0;
    margin-right: 8vw;
  }

  .tab {
    margin-bottom: 0.5vh;
    padding: 0.5vw 5vw 0.5vw 2vw;
    cursor: pointer;
    border-radius: 16px;
  }

  .tab-active {
    color: #0F46FF;
    font-weight: 600;
    background-color: #F7F8FA;
  }

  .content {
    display: flex;
    text-align: left;
  }

  .box1 {
    margin-right: 9vw;
  }

  .box1 .title {
    padding: 0.5vw 0;
    font-size: 32px;
    font-weight: 550;
    color: #020814;
    border-bottom: 2px solid #F2F3F5;
  }

  .box1 .dec {
    margin-top: 0.1vw;
  }

  .box1 .item {
    padding: 0.5vw 0;
    cursor: pointer;
  }

  .tab:hover {
    background-color: #F7F8FA;
  }

  .link {
    display: flex;
    align-items: center;
  }

  .link:hover {
    font-weight: 600;
    color: #0F46FF;
    cursor: pointer;
  }

  .active {
    font-weight: 550;
    color: #020814;
    border-bottom: 8px solid #020814;
    box-sizing: content-box;
  }

  .top-icon {
    margin-right: 1vw;
  }

  .footer {
    padding: 0 12.5vw 0;
    height: 32.1vh;
    background: #020814;
    font-weight: 400;
    font-size: 28px;
    color: rgba(255, 255, 255, 0.5);
    line-height: 58px;

    &-top {
      display: flex;
      justify-content: space-between;
      padding-top: 5.6vh;
      padding-bottom: 1.5vh;
      min-height: 22.2vh;
      border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    }

    &-top-left {
      padding-right: 160px;
    }

    &-title {
      margin-bottom: 2.4vh;
      font-weight: 500;
      font-size: 28px;
      color: #fff;
    }

    &-label {
      padding-left: 30px;
      color: rgba(255, 255, 255, 1)
    }

    &-bot {
      padding-top: 30px;
      text-align: center;

    }

    &-beian {
      margin-right: 14px;
      width: 32px;
      height: 34px;
      vertical-align: -6px;
    }

    .wx-img {
      width: 172px;
      height: 172px;
    }
  }

  /* 移动端样式开始 */
  .mobile-active {
    font-weight: 500;
    color: #020814;
  }

  .mobile-logo {
    margin-right: 60px;
    width: 336px;
    height: auto;
  }

  .mobile-menus-btn {
    margin-left: auto;
    margin-right: 40px;
    width: 64px;
    height: 64px;
    background: url('./assets/images/menu.png') center no-repeat;
    background-size: contain;
  }

  .mobile-menus {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-wrap: wrap;
    padding-top: 7.4vh;
    width: 100%;
    height: 7vh;
    background: rgba(255, 255, 255);
    z-index: 9999;
    transition: all 0.3s ease-in-out 0s;
    overflow: hidden;
  }

  .opened-menus {
    height: 22vh;
  }

  .mobile-menus-item {
    width: 32%;
    line-height: 6.6vh;
    text-align: center;
  }

  /* 热线 */
  .service-box {
    position: fixed;
    right: 114px;
    bottom: 240px;
    padding-top: 70px;
    width: 120px;
    height: 120px;
    text-align: center;
    font-size: 24px;
    color: #4E5969;
    border-radius: 16px;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.05);
    background: #fff url(./assets/images/tel.png) no-repeat center 16px;
    background-size: 48px 48px;
    cursor: pointer;
  }

  .service-box:hover {
    font-weight: 500;
    color: #0F46FF;
    background: #fff url(./assets/images/tel-active.png) no-repeat center 16px;
    background-size: 48px 48px;
  }

  .service-tel {
    position: fixed;
    right: 260px;
    bottom: 240px;
    padding: 0 40px;
    height: 120px;
    color: #020814;
    font-size: 36px;
    font-weight: 500;
    background: #fff;
    border-radius: 16px;
    transform: scale(0);
    transition: all 0.3s;
  }

  .service-box:hover+.service-tel {
    transform: scale(1);
  }
  .flex-box{
    display: flex;
    align-items: center;
  }
</style>